module.exports = __webpack_public_path__ + "static/media/doge.c7fd4d5d.svg";